<template>
  <nav>
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <div>
      <v-fab-transition v-if="(isAuth && threads.length >= 0 && role == 'booster') || (isAuth && threads.length > 0 && !existPrivateThread)">
      
        <v-btn 
          data-testid="open-activity-forum-icon"
          elevation="2"
          fixed
          right
          :color="mobile() ? '#F0F0F0' : ''"
          fab
          top
          :class="{ 'trial-absolute-button': ((productPlan.attributes && productPlan.attributes.name == 'Pro Trial') || subscriptionEnds || (productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))) && mobile(),  'trial-absolute-button-md': ((productPlan.attributes && productPlan.attributes.name == 'Pro Trial')|| subscriptionEnds || (productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))) && !mobile(), 'mt-13 mt-md-15' : !productPlan.attributes || (productPlan.attributes && productPlan.attributes.name != 'Pro Trial') && !subscriptionEnds  && !(productPlan.meta && (productPlan.meta.plan_properties.status == 'incomplete' || productPlan.meta.plan_properties.status == 'past_due'))}"
          style="z-index: 6" 
          @click="updateForumState"
          class="activity-forum-button"
        >
          <v-icon medium>
            mdi-message-reply-text
          </v-icon>
        </v-btn>
      </v-fab-transition>
      <v-navigation-drawer
        v-model="drawer"
        :class="mobile() || (showThread == false) ? 'navigation-drawer-mobile mt-0':'navigation-drawer-desktop mt-0'"
        overlay-opacity="1"
        hide-overlay
        clipped
        app
        color="background"
        fluid    
        width="100%"
        data-testid="navigation-drawer"
        style="z-index: 8; 
        max-width:400px"
        disable-resize-watcher
        right
        stateless
      >
        <template v-slot:prepend>
          <div style="position: relative;">
            <v-btn
              data-testid="close-activity-forum-icon"
              color="greytext--text"           
              absolute
              top
              left
              icon
              @click.stop="updateForumState"
            >
              <v-icon>mdi-forwardburger</v-icon>
            </v-btn>
            <h3 class="pt-5 pb-5 text-center">
              {{ $t('activityForumTitle') }}
            </h3>
            <v-divider v-if="showThread == false" />
            <v-spacer />
            <div v-if="showThread == false && role == 'booster'" style="height: 60px; margin-left: 1px;">
              <v-row class="ma-0"
              >
                <v-col
                  v-if="showThread == false"
                  cols="12"
                  class="pb-12 elevation-1 filled-row text-right"
                  color="white"
                  style="z-index: 98;"
                >
                  <v-btn
                    v-if="role == 'booster'"
                    data-testid="add-activity-forum-thread--icon"
                    color="greytext--text pt-2"           
                    icon
                    right
                    absolute
                    style="z-index: 99;"
                    @click.stop="dialogVisible=true"
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </div>
          </div>  
        </template> 
        <v-row
          v-if="threads.length == 0 && showThread == false && !loadingData"
          class="pa-4"
          align="center"
        >
          <v-col
            data-testid="empty-forum"
            cols="12"
            align="center"
            class="mt-10 mt-md-16 pt-10 pt-md-10 pt-lg-14"
          >
            <v-icon
              size="6em"
              color="greyactivitybackground"
              class="mx-auto mt-10 mt-md-16 mb-10 v-list-item__icon"
            >
              mdi-message-reply-text
            </v-icon>
            <p class="text-h5 font-weight-bold text-center">
              {{ $t('emptyForumThreadTitle') }}
            </p>
            <!-- eslint-disable vue/no-v-html -->
            <p
              v-if="role == 'booster'"
              class="text-body-1 text-center"
            >
              {{ $t('emptyForumThreadText') }}
            </p>
          </v-col>
        </v-row>
        <v-row
          v-if="threads.length >= 1 && showThread == false && !loadingData"
          class="pa-2"
        >
          <v-col
            v-for="item in threads"
            :key="item.id"
            cols="12"
            class="mb-2 py-0"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="auto"
                max-height="194px"
                data-testid="thread-card"
                rounded="xxl" 
                class="mx-auto rounded-xxl"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
                @click="showThreadDetail(item.id)"
              >
                <v-card-text class="py-0 px-4 px-sm-6">
                  <v-row class="pt-2">
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      class="pa-0"
                    >
                      <v-card-title
                        style="font-size: 16px;line-height:1.2em"
                        class="text-left darktext--text no-break pb-0 px-3"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ item.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      cols="2"
                      sm="2"
                      md="2"
                      class="pa-0"
                    >
                      <v-card-actions
                        class="pa-0  pt-3 float-right"
                      >
                        <v-btn
                          v-if="item.attributes.subscribed == false"
                          data-testid="subscribe-icon"
                          icon
                          
                          color="primary"
                         
                          @click.stop="selectedThreadItem = item.id,
                                       dialogVisibleSubscribeThread = true, 
                                       confirmationDialogTitle = $t('confirmationDialogTitleSubscribeThread'), 
                                       confirmationDialogText = $t('confirmationDialogTextSubscribeThread'), 
                                       confirmationDialogSubmitBtn = $t('yes')
                                       confirmationDialogCancelBtn = $t('no')"
                        >
                          <v-icon medium>
                            mdi-bell-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          data-testid="unsubscribe-icon"
                          icon
                          color="accent"
                          
                          @click.stop="selectedThreadItem = item.id,
                                       dialogVisibleUnsubscribeThread = true, 
                                       confirmationDialogTitle = $t('confirmationDialogTitleUnsubscribeThread'), 
                                       confirmationDialogText = $t('confirmationDialogTextUnsubscribeThread'), 
                                       confirmationDialogSubmitBtn = $t('yes')
                                       confirmationDialogCancelBtn = $t('no')"
                        >
                          <v-icon medium>
                            mdi-bell-ring
                          </v-icon>
                        </v-btn>
                        <v-menu
                          v-if="item.attributes.sharing_setting == 'Restricted' || item.attributes.is_manager == true"
                          class="float-right"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              class="mr-n2"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon
                                large
                                class="darktext--text"
                                data-testid="threedots-icon"
                              >
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list data-testid="menu-list-actions">
                            <v-list-item
                              v-if="item.attributes.sharing_setting == 'Restricted' && !item.attributes.is_for_all_activity_members"
                              data-testid="people-in-thread"
                              @click.stop="
                                dialogVisiblePeopleInThread=true, 
                                selectedThreadItem=item
                                confirmationDialogTitle=$t('confirmationDialogTitleWithoutLoginForumPopup')"
                            >
                              <v-list-item-title> {{ $t('people') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="item.attributes.is_manager == true"
                              data-testid="settings"
                              @click.stop="
                                selectedThreadItem=item
                                dialogVisibleEditThread = true"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="item.attributes.sharing_setting == 'Restricted' && !item.attributes.is_owner"
                              data-testid="leave-thread"
                              @click.stop="
                                selectedThreadItem = item.id,
                                dialogVisibleLeaveThread = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleLeaveThread'), 
                                confirmationDialogText = $t('confirmationDialogTextLeaveThread'), 
                                confirmationDialogSubmitBtn = $t('leave')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('leaveThread') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="item.attributes.is_manager == true"
                              data-testid="remove-thread"
                              @click.stop="
                                selectedThreadItem = item.id,
                                dialogVisibleRemoveThread = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveThread'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveThread'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteThread') }} </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="pa-3"
                    >
                      <p
                        style="max-height:60px"
                        class="text-caption align-self-center mb-0"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ item.attributes.description }}
                        </v-clamp>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="pb-2">
                    <v-col
                      cols="4"
                      class="text-caption"
                    >
                      {{ format_date(item.attributes.created_at) }}
                    </v-col>
                    <v-col
                      v-if="item.attributes.sharing_setting == 'Restricted'"
                      cols="4"
                      data-testid="sharing-setting-private"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-account-circle-outline
                      </v-icon> 
                      <span
                        v-if="item.attributes.is_for_all_activity_members"
                        data-testid="users-private-thread"
                        class="text-caption"
                      > {{ $t('everyone') }} 
                      </span>
                      <span
                        v-else
                        data-testid="users-private-thread"
                        class="text-caption"
                      > {{ item.relationships.users.meta.count }} 
                      </span>
                    </v-col>
                    <v-col
                      v-if="item.attributes.sharing_setting == 'Open'"
                      cols="4"
                      data-testid="sharing-setting-open"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-account-circle-outline
                      </v-icon> 
                      <span
                        class="text-caption"
                      > {{ $t('sharingSettingOpen') }} </span>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-message-reply-outline
                      </v-icon>
                      <span
                        data-testid="comments-private-thread"
                        class="text-caption"
                      > {{ item.relationships.comments.meta.count }} </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row
          v-if="showThread == true && !loadingData"
          no-gutters
          :class="mobile()?'':'thread-card'"
        >
          <v-col
            cols="12"
            class="pt-0 pr-0"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                height="200px"
                data-testid="thread-card-view"
                
                class="mx-auto rounded-b-xl"
                :ripple="false"
                :class="`elevation-${hover? 8 : 2 } ${hover? 'v-card--shadow': 'v-card--flat'}`"
              >
                <v-btn   
                  class="ml-2 mt-2"    
                  icon
                  @click.stop="showThreads"
                >
                  <v-icon 
                    medium
                  >
                    mdi-chevron-left
                  </v-icon>
                </v-btn>
                <v-card-text class="py-0 px-6">
                  <v-row>
                    <v-col
                      cols="10"
                      sm="10"
                      md="10"
                      class="pa-0"
                    >
                      <v-card-title
                        style="font-size: 16px;line-height:1.2em"
                        class="text-left darktext--text no-break py-2 px-3"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="2"
                        >
                          {{ thread.attributes.title }}
                        </v-clamp>
                      </v-card-title>
                    </v-col>
                    <v-col
                      cols="2"
                      sm="2"
                      md="2"
                      class="px-0 mt-n11 "
                    >
                      <v-card-actions
                        class="pa-0 float-right"
                      >
                        <v-btn
                          v-if="thread.attributes.subscribed == false"
                          data-testid="subscribe-button"
                          icon
                          
                          color="primary"
                         
                          @click.stop="selectedThreadItem = thread.id,
                                       dialogVisibleSubscribeThread = true, 
                                       confirmationDialogTitle = $t('confirmationDialogTitleSubscribeThread'), 
                                       confirmationDialogText = $t('confirmationDialogTextSubscribeThread'), 
                                       confirmationDialogSubmitBtn = $t('yes')
                                       confirmationDialogCancelBtn = $t('no')"
                        >
                          <v-icon medium>
                            mdi-bell-outline
                          </v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          data-testid="unsubscribe-button"
                          icon
                          color="accent"
                          
                          @click.stop="selectedThreadItem = thread.id,
                                       dialogVisibleUnsubscribeThread = true, 
                                       confirmationDialogTitle = $t('confirmationDialogTitleUnsubscribeThread'), 
                                       confirmationDialogText = $t('confirmationDialogTextUnsubscribeThread'), 
                                       confirmationDialogSubmitBtn = $t('yes')
                                       confirmationDialogCancelBtn = $t('no')"
                        >
                          <v-icon medium>
                            mdi-bell-ring
                          </v-icon>
                        </v-btn>
                        <v-menu
                          v-if="thread.attributes.sharing_setting == 'Restricted' || thread.attributes.is_manager == true"
                          class="float-right"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon
                                large
                                class="darktext--text"
                                data-testid="threedots-icon"
                              >
                                mdi-dots-vertical
                              </v-icon>
                            </v-btn>
                          </template>
                          <v-list data-testid="menu-list-actions">
                            <v-list-item
                              v-if="thread.attributes.sharing_setting == 'Restricted' && !thread.attributes.is_for_all_activity_members"
                              @click.stop="
                                dialogVisiblePeopleInThread=true, 
                                selectedThreadItem = thread
                                confirmationDialogTitle=$t('confirmationDialogTitleWithoutLoginForumPopup')"
                            >
                              <v-list-item-title> {{ $t('people') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="thread.attributes.is_manager == true"
                              data-testid="settings"
                              @click.stop="
                                selectedThreadItem = thread
                                dialogVisibleEditThread = true"
                            >
                              <v-list-item-title> {{ $t('settings') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="thread.attributes.sharing_setting == 'Restricted' && !thread.attributes.is_owner"
                              data-testid="leave-thread"
                              @click.stop="
                                selectedThreadItem = thread.id,
                                dialogVisibleLeaveThread = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleLeaveThread'), 
                                confirmationDialogText = $t('confirmationDialogTextLeaveThread'), 
                                confirmationDialogSubmitBtn = $t('leave')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('leaveThread') }} </v-list-item-title>
                            </v-list-item>
                            <v-list-item
                              v-if="thread.attributes.is_manager == true"
                              data-testid="remove-thread"
                              @click.stop="
                                selectedThreadItem = thread.id,
                                dialogVisibleRemoveThread = true, 
                                confirmationDialogTitle = $t('confirmationDialogTitleRemoveThread'), 
                                confirmationDialogText = $t('confirmationDialogTextRemoveThread'), 
                                confirmationDialogSubmitBtn = $t('delete')
                                confirmationDialogCancelBtn = $t('no')"
                            >
                              <v-list-item-title> {{ $t('deleteThread') }} </v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </v-card-actions>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      class="px-3 py-1"
                    >
                      <p
                        style="font-size: 12px;height:60px"
                        class="text-body-2 align-self-center mb-0"
                      >
                        <v-clamp
                          autoresize
                          :max-lines="3"
                        >
                          {{ thread.attributes.description }}
                        </v-clamp>
                      </p>
                    </v-col>
                  </v-row>
                  <v-row class="pb-2 mt-n2">
                    <v-col
                      cols="4"
                      class="text-caption"
                    >
                      {{ format_date(thread.attributes.created_at) }}
                    </v-col>
                    <v-col
                      v-if="thread.attributes.sharing_setting == 'Restricted'"
                      cols="4"
                      data-testid="sharing-setting-private"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-account-circle-outline
                      </v-icon>
                      <span
                        v-if="thread.attributes.is_for_all_activity_members"
                        data-testid="users-private-thread"
                        class="text-caption"
                      > {{ $t('everyone') }} 
                      </span>
                      <span
                        v-else
                        data-testid="users-private-thread"
                        class="text-caption"
                      > {{ thread.relationships.users.meta.count }} 
                      </span>
                    </v-col>
                    <v-col
                      v-if="thread.attributes.sharing_setting == 'Open'"
                      cols="4"
                      data-testid="sharing-setting-open"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-account-circle-outline
                      </v-icon>
                      <span
                        class="text-caption"
                      > {{ $t('sharingSettingOpen') }} </span>
                    </v-col>
                    <v-col
                      cols="4"
                    >
                      <v-icon 
                        medium
                        color="greytextlight"
                      >
                        mdi-message-reply-outline
                      </v-icon>  
                      <span
                        data-testid="comments-private-thread"
                        class="text-caption"
                      > {{ totalComments }} </span>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-hover>
          </v-col>
        </v-row>
        <v-row
          v-if="showThread == true && !loadingData"
          no-gutters
          :class="mobile() ? '' : 'thread-comments'"
          :style="mobile() ? &quot;height:auto&quot; : &quot;height:calc(100% - 200px)&quot;"
        >
          <v-col
            class="py-3"
            data-testid="thread-comment-view"
          >
            <v-row
              v-if="comments.length == 0 && !loadingData"
              class="fill-height mx-auto"
              style="width:100%"
              align="center"
            >
              <v-col
                data-testid="empty-comment-block"
                cols="12"
                align="center"
              >
                <v-icon
                  size="6em"
                  color="greyactivitybackground"
                  class="mx-auto my-10 mt-md-16 v-list-item__icon"
                >
                  mdi-message-reply-text
                </v-icon>
                <p class="text-h5 font-weight-bold text-center">
                  {{ $t('emptyForumCommentsTitle') }}
                </p>
                <!-- eslint-disable vue/no-v-html -->
                <p
                  class="text-body-1 text-center"
                >
                  {{ $t('emptyForumCommentsText') }}
                </p>
              </v-col>
            </v-row>

            <v-row
              v-if="comments.length > 0 && !loadingData"
              no-gutters
            >           
              <v-col
                v-for="itemComment in comments"
                :key="itemComment.id"
                data-testid="comments-block"
                cols="12"
                class="py-0 px-4"
                height="124px"
              >
                <v-row 
                  v-if="itemComment.attributes.is_deleted == 0"
                  class="comment-item"
                >
                  <v-col
                    cols="12"
                    :class="itemComment.attributes.is_pinned != 1 ? 'pin' : 'unpin'"
                  >
                    <v-row>
                      <v-col
                        cols="2"
                        sm="2"
                        md="2"
                        align="center"
                      >
                        <v-avatar
                          size="48"
                          class="mx-2"
                        >
                          <img
                            v-if="itemComment.meta.user.data.attributes.avatar_thumb == null"
                            :src="defaultImage"
                          >
                          <img
                            v-else
                            :src="`${itemComment.meta.user.data.attributes.avatar_thumb}`"
                          >
                        </v-avatar>
                      </v-col>
                      <v-col
                        cols="8"
                        sm="8"
                        md="8"
                        class="ml-1 mr-n1"
                        align="left"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{on}">
                            <p
                              class="text-body-1 darktext--text text-truncate mb-0 mt-n1"
                              v-on="on"
                            >
                              {{ itemComment.meta.user.data.attributes.first_name }}  {{ itemComment.meta.user.data.attributes.last_name }}
                            </p>
                          </template>
                          <span>{{ itemComment.meta.user.data.attributes.first_name }}  {{ itemComment.meta.user.data.attributes.last_name }}</span>
                        </v-tooltip>
                        <p
                          class="darktext--text mb-0"
                          style="font-size: 10px;"
                        >
                          {{ format_date(itemComment.attributes.created_at) }} 
                        </p>
                        <div
                          v-show="!readMore[itemComment.id] && (itemComment.attributes.comment.length > 86 || itemComment.attributes.attachments.length > 0)"
                          class="darktext--text mb-0 no-break comment"
                          style="font-size: 13px;"
                        >
                          <span v-linkified:options="{ defaultProtocol: 'https', format: { url: (value) => value.length > 50 ? value.slice(0, 50) + '…' : value }, nl2br: true }">
                            {{ itemComment.attributes.comment ? itemComment.attributes.comment.substring(0, 86) + "..." : '' }}
                          </span>
                          <div
                            v-if="itemComment.attributes.attachments.length > 0"
                            class="attachments my-2 d-block"
                            style="width:220px;"
                          >
                            <v-row
                              no-gutters
                              align-content="center"
                              justify="center"
                            >
                              <v-col
                                cols="12"
                                align-self="center"
                                justify="center"
                              >
                                <a
                                  class="attachments-more elevation-2 px-4 d-flex greytext--text rounded-xxl text-caption align-center"
                                  style="height: 40px;"
                                  @click="showMore(itemComment.id)"
                                >
                                  {{ $t('attachments') }} ({{ itemComment.attributes.attachments.length }})
                                </a>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                        
                        <div
                          v-show="readMore[itemComment.id] || (itemComment.attributes.comment.length < 86 && itemComment.attributes.attachments.length == 0)"
                          class="darktext--text mb-0 no-break comment"
                          style="font-size: 13px;"
                        >
                          <span v-linkified:options="{ defaultProtocol: 'https', format: { url: (value) => value.length > 50 ? value.slice(0, 50) + '…' : value }, nl2br: true }">
                            {{ itemComment.attributes.comment }}
                          </span>
                          <div
                            class="attachments my-2 d-block"
                            style="width:220px;"
                          >
                            <v-card
                              v-for="(itemAttachment,index) in itemComment.attributes.attachments"
                              :key="index"
                              rounded="xxl"
                              class="mb-2"
                            >
                              <v-row
                                no-gutters
                                style="height: 40px;"
                                align-content="center"
                                justify="center"
                                class="px-2"
                              >
                                <v-col
                                  cols="2"
                                  class="d-flex justify-center"
                                  align-self="center"
                                >
                                  <span
                                    :style="`color: `+itemAttachment.ext.color"
                                    :class="`mdi mdi-24px `+itemAttachment.ext.icon"
                                  >&nbsp;</span>
                                </v-col>
                                <v-col
                                  cols="8"
                                  align-self="center"
                                  justify="center"
                                >
                                  <span
                                    data-testid="attachment-title"
                                    class=" text-truncate d-block text-caption attachment-title "
                                  > {{ itemAttachment.title }} 
                                  </span> 
                                </v-col>
                                <v-col
                                  cols="2"
                                  data-testid="download-attachment"
                                  class="d-flex justify-center"
                                  align-self="center"
                                >
                                  <a
                                    :href="itemAttachment.url"
                                    target="”_blank”"
                                  ><span
                                    style="color: #7c8386"
                                    class=" mdi mdi-24px mdi-download"
                                  ></span></a>
                                </v-col>
                              </v-row>
                            </v-card>
                          </div>
                        </div>
                        <a
                          v-if="(!readMore[itemComment.id] && itemComment.attributes.comment.length > 86) || (!readMore[itemComment.id] && itemComment.attributes.attachments.length > 0)"
                          class="text-caption"
                          data-testid="read-more"
                          @click="showMore(itemComment.id)"
                        >{{ $t('readMore') }}</a>
                        <a
                          v-if="readMore[itemComment.id]"
                          class="text-caption"
                          data-testid="read-less"
                          @click="showLess(itemComment.id)"
                        >{{ $t('readLess') }}</a>
                      </v-col>
                            
                      <v-col
                        v-if="(userId == itemComment.meta.user.data.id) || thread.attributes.is_manager == true"
                        cols="1"
                        class="pa-0"
                      >
                        <v-btn
                          data-testid="delete-comment-button"
                          icon
                          small
                          class="mt-n2 dots-vertical"
                          @click.stop="
                            selectedThreadItemComment = itemComment.id,
                            dialogVisibleRemoveThreadComment = true, 
                            confirmationDialogTitle = $t('confirmationDialogTitleRemoveThreadComment'), 
                            confirmationDialogText = $t('confirmationDialogTextRemoveThreadComment'), 
                            confirmationDialogSubmitBtn = $t('delete')
                            confirmationDialogCancelBtn = $t('no')"
                        >
                          <v-icon small>
                            mdi-delete
                          </v-icon>
                        </v-btn>
                      </v-col>
                      <v-col
                        v-else
                        cols="1"
                        class="pa-0"
                      />
                      <div v-if="thread.attributes.sharing_setting == 'Restricted'">
                        <v-col
                          v-if="thread.attributes.is_owner == true"
                          cols="1"
                          class="pa-0"
                        >
                          <v-btn
                            v-if="itemComment.attributes.is_pinned != 1"
                            data-testid="pin-comment-button"
                            icon
                            small
                            color="primary"
                            class="mt-n2 dots-vertical"
                            @click.stop="pinThreadComment(itemComment)"
                          >
                            <v-icon small>
                              mdi-pin
                            </v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            data-testid="unpin-comment-button"
                            icon
                            color="warning"
                            class="mt-n2"
                            small
                            style="background-color:rgba(251, 192, 45, 0.12);"
                            @click.stop="pinThreadComment(itemComment)"
                          >
                            <v-icon small>
                              mdi-pin mdi-rotate-45
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col
                          v-else
                          cols="1"
                          class="pa-0"
                        >
                          <v-btn
                            v-if="itemComment.attributes.is_pinned == 1"
                            data-testid="pin-comment-button"
                            icon
                            color="warning"
                            class="mt-n2"
                            small
                            disabled
                            style="background-color:rgba(251, 192, 45, 0.12);"
                          >
                            <v-icon small>
                              mdi-pin mdi-rotate-45
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </div>
                      <div v-if="thread.attributes.sharing_setting == 'Open'">
                        <v-col
                          v-if="thread.attributes.is_manager == true"
                          cols="1"
                          class="pa-0"
                        >
                          <v-btn
                            v-if="itemComment.attributes.is_pinned != 1"
                            data-testid="pin-comment-button"
                            icon
                            small
                            color="primary"
                            class="mt-n2 dots-vertical"
                            @click.stop="pinThreadComment(itemComment)"
                          >
                            <v-icon small>
                              mdi-pin
                            </v-icon>
                          </v-btn>
                          <v-btn
                            v-else
                            data-testid="unpin-comment-button"
                            icon
                            color="warning"
                            class="mt-n2"
                            small
                            style="background-color:rgba(251, 192, 45, 0.12);"
                            @click.stop="pinThreadComment(itemComment)"
                          >
                            <v-icon small>
                              mdi-pin mdi-rotate-45
                            </v-icon>
                          </v-btn>
                        </v-col>
                        <v-col
                          v-else
                          cols="1"
                          class="pa-0"
                        >
                          <v-btn
                            v-if="itemComment.attributes.is_pinned == 1"
                            data-testid="pin-comment-button"
                            icon
                            color="warning"
                            class="mt-n2"
                            small
                            disabled
                            style="background-color:rgba(251, 192, 45, 0.12);"
                          >
                            <v-icon small>
                              mdi-pin mdi-rotate-45
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </div>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row v-else>
                  <v-col
                    cols="12"
                    sm="12"
                    md="12"
                    align="center"
                  >
                    <v-card
                      v-if="itemComment.attributes.deleted_by == 'author'"
                      elevation="0"
                      outlined
                      rounded="xxl"
                    >
                      <v-card-subtitle class="py-2">
                        {{ $t('commentRemovedByAuthor') }}
                      </v-card-subtitle>
                    </v-card>
                    <v-card
                      v-else
                      elevation="0"
                      outlined
                      rounded="xxl"
                    >
                      <v-card-subtitle class="py-2">
                        {{ $t('commentRemovedByOwner') }}
                      </v-card-subtitle>
                    </v-card>
                  </v-col>
                </v-row>
                <v-divider />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      
        <template
          v-if="showThread == true"
          v-slot:append
        >
          <v-form
            v-if="isLocked == false"  
            ref="form"
            v-model="valid"
            @keyup.enter="createComment()"
            @submit.prevent
          >
            <v-row class="mb-0">
              <v-col
                cols="10"
                class="pr-0"
              >
                <div class="v-input mt-3 px-3 comments-input v-textarea v-input--hide-details theme--light v-text-field v-text-field--single-line v-text-field--filled v-text-field--is-booted v-text-field--enclosed v-text-field--placeholder">
                  <div class="v-input__control">
                    <div
                      class="textarea-autosize"
                    >
                      <v-row>
                        <!-- <div class="v-text-field__slot"> -->
                        <v-col
                          cols="10"
                          class="py-0"
                        >
                          <textarea-autosize
                            v-model="comment"
                            data-testid="textarea-for-comment"
                            filled
                            background-color="white"
                            :min-height="20"
                            :max-height="50"
                            rows="1"
                            error
                            class="pt-3 mx-2"
                            name="textarea"
                            :placeholder="$t('commentPlaceholder')"
                            :disabled="commentIsDisabled"
                            @keydown.enter.native.exact.prevent
                            @keyup.enter.native.exact="createComment()"
                            @keydown.enter.shift.native.exact="newline"
                          />
                        <!-- </div> -->
                        </v-col>
                        <v-col
                          cols="2"
                          class="py-0"
                        >
                          <v-file-input
                            v-model="fileData"
                            data-testid="attachment-icon"
                            :disabled="attachmentsCount == 5 || loadingUpload" 
                            hide-input
                            class="pb-3 pt-0 mr-n3"
                            accept="image/png, image/jpeg, .pdf, .ppt, .pptx, .doc, .docx, .xls, .xlsx, .odt, .csv, .ods, .rtf, .txt"
                            @change="uploadFile"
                          />
                        </v-col>
                      </v-row>
                    </div>
                    <div
                      v-for="(itemAttachment,index) in attachments"
                      :key="index"
                      class="textarea-autosize"
                      style="background-color:white"
                    >
                      <v-row
                        no-gutters
                        style="width:310px"
                         
                        class="pa-1"
                      >
                        <v-col
                          cols="1"
                        >
                          <span
                            :style="`color: `+itemAttachment.ext.color"
                            :class="`mdi mdi-24px `+itemAttachment.ext.icon"
                          >&nbsp;</span>
                        </v-col>
                        <v-col
                          cols="10"
                        >
                          <v-clamp
                            autoresize
                            :max-lines="1"
                            class="text-caption"
                          >
                            {{ itemAttachment.title }} 
                          </v-clamp> 
                        </v-col>
                        <v-col
                          cols="1"
                        >
                          <v-btn
                            data-testid="delete-comment-button"
                            icon
                            small
                            class=""
                            @click.stop="removeFile(itemAttachment)"
                          >
                            <v-icon
                              small
                              color="black"
                            >
                              mdi-close
                            </v-icon>
                          </v-btn>
                        </v-col>
                      </v-row>
                    </div>
                    <span
                      v-if="attachmentsCount"
                      color="primary"
                      class="text-right pa-1 text-caption"
                    >{{ attachmentsCount }}/5</span>
                  </div>
                </div>
              </v-col>
              <v-col
                cols="1"
                class="pl-0 pb-4 d-flex justify-space-between align-end"
              >
                <v-btn
                  data-testid="submit-button"
                  class="mt-3 px-0 mx-0"
                  icon
                  color="accent"
                  :disabled="commentIsDisabled"
                  @keyup.enter="createComment()"
                  @click="createComment()"
                >
                  <v-icon 
                    medium
                  >
                    mdi-send
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </v-navigation-drawer>
      <ConfirmationDialog
        v-if="dialogVisibleRemoveThread"
        ref="confirmationDialogRemoveThread"
        :visible="dialogVisibleRemoveThread" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        data-testid="confirmation-dialog-delete-thread" 
        @close="dialogVisibleRemoveThread= false"
        @proceedSubmit="removeThread(selectedThreadItem)"
      /> 
      <ConfirmationDialog
        v-if="dialogVisibleLeaveThread"
        ref="confirmationDialogLeaveThread"
        :visible="dialogVisibleLeaveThread" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        data-testid="confirmation-dialog-leave-thread" 
        @close="dialogVisibleLeaveThread= false"
        @proceedSubmit="leaveThread(selectedThreadItem)"
      /> 
      <ConfirmationDialog
        v-if="dialogVisibleSubscribeThread"
        ref="confirmationDialogSubscribeThread"
        :visible="dialogVisibleSubscribeThread" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn"
        cd-submit-btn-color="accent" 
        data-testid="confirmation-dialog-subscribe-thread" 
        @close="dialogVisibleSubscribeThread= false"
        @proceedSubmit="subscribeForEmailNotification(selectedThreadItem)"
      /> 
      <ConfirmationDialog
        v-if="dialogVisibleUnsubscribeThread"
        ref="confirmationDialogUnsubscribeThread"
        :visible="dialogVisibleUnsubscribeThread" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn"
        cd-submit-btn-color="accent" 
        data-testid="confirmation-dialog-unsubscribe-thread" 
        @close="dialogVisibleUnsubscribeThread= false"
        @proceedSubmit="unsubscribeForEmailNotification(selectedThreadItem)"
      />
      <ConfirmationDialog
        v-if="dialogVisibleRemoveThreadComment"
        ref="confirmationDialogRemoveThreadComment"
        :visible="dialogVisibleRemoveThreadComment" 
        :cd-title="confirmationDialogTitle" 
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        data-testid="confirmation-dialog-delete-thread-comment" 
        @close="dialogVisibleRemoveThreadComment= false"
        @proceedSubmit="removeThreadComment(selectedThreadItemComment)"
      /> 

      <ConfirmationDialogActivityForumThread 
        v-if="dialogVisible"
        :visible="dialogVisible" 
        data-testid="activity-forum-thread-dialog" 
        @close="dialogVisible=false"
        @proceedSubmit="addForumThread"
      />
      <ConfirmationDialogActivityForumEditThread 
        v-if="dialogVisibleEditThread"
        :visible="dialogVisibleEditThread" 
        :item="selectedThreadItem"
        data-testid="edit-thread-dialog" 
        @close="dialogVisibleEditThread=false"
        @proceedSubmit="updateForumThread"
      />
      <ConfirmationDialogPeopleInThread 
        v-if="dialogVisiblePeopleInThread"
        :visible="dialogVisiblePeopleInThread" 
        :item="selectedThreadItem"
        data-testid="people-in-thread-dialog" 
        @proceedSubmit="showUpdateUserListInThreadMessage"
        @close="dialogVisiblePeopleInThread =false"
      />
      <ConfirmationDialogWithLink 
        v-if="dialogVisibleForum"
        ref="confirmationDialogForumForAnonymous"
        :visible="dialogVisibleForum"
        :cd-title="confirmationDialogTitle"
        :cd-text="confirmationDialogText" 
        :cd-submit-btn="confirmationDialogSubmitBtn" 
        :cd-link-btn="confirmationDialogLinkBtn" 
        :cd-cancel-btn="confirmationDialogCancelBtn" 
        :cd-cancel-btn-color="cdCancelBtnColor" 
        :cd-submit-btn-color="cdSubmitBtnColor" 
        data-testid="confirmation-dialog-forum-anonymous"  
        @clickOutSide="dialogVisibleForum=false"
        @close="dialogVisibleForum=false"
        @proceedSubmit="login"
        @proceedLink="createNewAccount"
      />
    </div>
  </nav>
</template>
<script>
import { createActivityForumThread,getThreadsForActivity,getActivity } from '../api/activityApi'
import i18n from '../plugins/i18n';
import VClamp from 'vue-clamp';
import { repeatedMethodsMixin } from '../mixins/repeatedMethodsMixin'
import ConfirmationDialog from './ConfirmationDialog'
import ConfirmationDialogActivityForumThread from './ConfirmationDialogActivityForumThread'
import ConfirmationDialogPeopleInThread from './ConfirmationDialogPeopleInThread'
import ConfirmationDialogActivityForumEditThread from './ConfirmationDialogActivityForumEditThread'
import ConfirmationDialogWithLink from './ConfirmationDialogWithLink'
import { addUsersToThread,createComments,getThreadComments, updateThread, deleteThread, leaveThread, deleteCommentThread,pinCommentThread,getThread,subscribeToThread,unsubscribeToThread, uploadFileComment,removeFileComment} from '../api/forumApi'
import moment from 'moment'
import AlertMessages  from './AlertMessages'


export default {
  name: "NavbarForum",
  components: {
      VClamp,
      ConfirmationDialogActivityForumThread,
      ConfirmationDialogActivityForumEditThread,
      ConfirmationDialogPeopleInThread, 
      ConfirmationDialogWithLink,
      ConfirmationDialog,
      AlertMessages
  },
  mixins: [repeatedMethodsMixin],
  props: {
    activityId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      valid:true,
      drawer: false,
      dialogVisible: false,
      dialogVisibleForum:false,
      isAuth: window.$cookies.get("token")? true: false,
      defaultImage: require('../assets/user_images/profile-avatar.png'),
      subscriptionEnds: localStorage.space ? JSON.parse(localStorage.space).subscription_ends_at: '',
      space: window.location.host.split('.')[0],
      confirmationDialogTitle: '',
      confirmationDialogText: '',
      confirmationDialogCancelBtn: '',
      confirmationDialogSubmitBtn: '',
      confirmationDialogLinkBtn:'',
      cdSubmitBtnColor:'',
      cdCancelBtnColor:'',
      role:'',
      isLocked:false,
      threads:[],
      comments:[],
      attachments:[],
      loadingData:false,
      showThread:false,
      comment:'',
      dialogVisibleEditThread:false,
      threadId:null,
      buttonDisabled:false,
      selectedThreadItem: {},
      alertMsg: '',
      alertType: '',
      alertValue:false,
      readMore: {},
      dialogVisiblePeopleInThread: false,
      dialogVisibleRemoveThread:false,
      dialogVisibleRemoveThreadComment:false,
      dialogVisibleLeaveThread:false,
      dialogVisibleSubscribeThread:false,
      dialogVisibleUnsubscribeThread:false,
      sharingSettings:null,
      commentIsDeleted:null,
      commentOwner:'',
      userId: window.$cookies.get('id'),
      activityType:'',
      totalComments:0,
      totalUsers:0,
      existPrivateThread:false,
      loadingUpload:false,
      fileData:null,
      spaceId: window.$cookies.get('space_id'),
      attachmentIcons: [
                {type: 'jpeg', color: '#00C853', icon: 'mdi-file-jpg-box'},					
                {type: 'jpg', color: '#00C853', icon: 'mdi-file-jpg-box'},					
                {type: 'png', color: '#2962FF', icon: 'mdi-file-png-box'},					
                {type: 'pdf', color: '#ff1744', icon: 'mdi-file-pdf-box'},					
                {type: 'ppt', color: '#FBC02D', icon: 'mdi-file-powerpoint-outline'},					
                {type: 'pptx', color: '#FBC02D', icon: 'mdi-file-powerpoint-outline'},					
                {type: 'doc', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {type: 'docx', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {type: 'xls', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {type: 'xlsx', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {type: 'odt', color: '#2979FF', icon: 'mdi-file-document-outline'},					
                {type: 'csv', color: '#00C853', icon: 'mdi-file-delimited-outline'},					
                {type: 'ods', color: '#00C853', icon: 'mdi-file-excel-outline'},					
                {type: 'rtf', color: '#7C8386', icon: 'mdi-file-document-outline'},					
                {type: 'txt', color: '#7C8386', icon: 'mdi-file-document-outline'}
            ],
            attachmentIcon:{},
            attachmentExtension: '',
            commentIsDisabled: false,


    };
  },
  computed:{
    attachmentsCount(){
      return this.attachments.length
    },
    productPlan() {
      return this.$store.state.productPlan;
    },
  },
  async created(){
    this.loadingData = true 
    this.getActivity()
    if(this.isAuth == true){
      await this.fetchThreadsForActivity()
      
    }
    if(this.$route.query.thread){
      this.drawer = true
      this.showThread = true
      await this.showThreadDetail(this.$route.query.thread)
    }
    this.loadingData = false     
  },
  methods: {
    newline() {
      this.comment = `${this.comment}`;
    },
    showMore(id) {
      this.$set(this.readMore, id, true);
    },
    showLess(id) {
      this.$set(this.readMore, id, false);
    },
    async showThreads(){
      await this.fetchThreadsForActivity()
      this.showThread = false
      this.comment =''
    },
    async showThreadDetail(item){ 

    this.showThread = true
    this.threadId = item
        try {
            this.loadingData = true 
            const response = await getThread(this.threadId)
              if(response.status == 200) {
                  this.thread = response.data.data
                this.isLocked = response.data.data.attributes.is_locked
                  await this.fetchThreadComments()
                  
              }  
        } catch (e) {
            if(e.response){
              if(e.response.status == 404) {
                await this.showThreads()
              }else{
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
              }
            } 
        }     
        this.loadingData = false
    },
    showUpdateUserListInThreadMessage(msg, type,itemId,numberPeople){
      if(this.showThread == false){
            this.threads.forEach(item => {
              if(item.id == itemId){
                item.relationships.users.meta.count = numberPeople 
              }      
            })
      }else{
        if(this.thread.id == itemId){
          this.thread.relationships.users.meta.count = numberPeople
        }
      }
      if(msg) {

          this.alertType= type
          this.alertMsg = msg
          this.alertValue = true
      }
    },
    format_date(value){
        if (value) {
          return moment(String(value)).format('DD MMM YYYY')
        }
    },
    updateForumState(){
      this.drawer = !this.drawer

      if (this.drawer == false) { 
         let hasclass = document.getElementsByClassName('custom-draft-tag');
          if (hasclass.length > 0) {
            document.querySelector('.custom-draft-tag').classList.add('custom-draft-tag-style-more-right')
            document.querySelector('.custom-draft-tag').classList.remove('custom-draft-tag-style-less-right')
          }
      } else {
          let hasclass = document.getElementsByClassName('custom-draft-tag');
          if (hasclass.length > 0) {
              document.querySelector('.custom-draft-tag').classList.remove('custom-draft-tag-style-more-right')
              document.querySelector('.custom-draft-tag').classList.add('custom-draft-tag-style-less-right')
          }
      }
    },
    createNewAccount(){
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/register?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId 
    },
    login(){
        window.location.href = process.env.VUE_APP_PROTOCOL + "://id." + process.env.VUE_APP_DOMAIN + "/login?referer=" + this.space + '.' + process.env.VUE_APP_DOMAIN + "/activity/" + this.activityId
    },
    async getActivity(){
        try {
            const response = await getActivity(this.activityId)
            if(response.status == 200) {
                this.role = response.data.data.attributes.role
                this.activityType = response.data.data.attributes.sharing_setting
                this.sharingSettings = response.data.data.relationships['sharing-setting'].data.id
            }  
        } catch (e) {
            if(e.response){
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
            } 
        }
    }, 
    async addForumThread(title, description,selectedUsers,forumType, includeAll){

        this.loadingData = true
          try {
            let data = {
                data: {
                    type: "threads", 
                    attributes: {
                        title: title.trim(),
                        description: description,
                        is_for_all_activity_members: includeAll
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.activityId
                            }
                        },
                        "sharing-setting": {
                            data: {
                                type: "sharing-settings",
                                id: forumType
                            }
                        }

                    }
                }
            };
            var response = await createActivityForumThread(data);
            if(response){
                if(response.status == 201) {
                    if(forumType == '1'){
                      await this.addUsersToThread(response.data.data.id,selectedUsers)
                    }
                    this.dialogVisible=false
                }
            }
        } catch (e) {
            if(e.response){
                if (e.response.status == 422 ){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                } else if (e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                } else {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }else{
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')       
            }
            this.dialogVisible=false
        }
        
        await this.fetchThreadsForActivity()
        this.loadingData = false
    },
    async addUsersToThread(id,selectedUsers){
        this.loading = true
        try {
            let data = {
                data: {
                    type: "thread-users", 
                    attributes: {
                        user_email: selectedUsers,
                    }
                }
            };
            const response = await addUsersToThread(id,data)
            if(response.status == 200) {
                //console.log('200')
            }            
        } catch (e) {
            if(e.response){
                this.alertValue = true
                if(e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                } else if(e.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
                } else {
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }            
        }
        this.loading =false  
    },
    async fetchThreadsForActivity(){
        try {
            const response = await getThreadsForActivity(this.activityId)
            if(response.status){
                if(response.status == 200) {
                    this.threads = response.data.data
                    this.threads.forEach(item => {
                      if(item.relationships.sharing_setting.data.id == 1){
                        this.existPrivateThread = true
                      } 
                    })
                }
            }            
        } catch (e) {
            if(e.response){
                if(e.response.status == 403){
                    this.$router.push({name: 'PageAccessDenied'})
                } else if(e.response.status == 404) {
                      this.$router.push({name: 'PageNotFound'})
                } else if(e.response.status == 451) {
                      //nothing
                } else {
                  this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
        }
    },
    async updateForumThread(title,description,typeId,itemId){
        try {
            let data = {
                data: {
                    type: "threads",
                    id: itemId, 
                    attributes: {
                        title: title.trim(),
                        description: description

                    },
                    relationships: {
                          activity:{
                                data:{
                                    type:"activities",
                                    id:this.activityId
                                }
                            },
                          "sharing-setting": {
                              data: {
                                  type: "sharing-settings",
                                  id: typeId
                              }
                          }
                    },
                }
              };

              var response = await updateThread(itemId, data);
              if(response.status == 200) {
                this.dialogVisibleEditThread=false
                this.threadTitle =  title
                this.threadDescription = description
                this.alertMsg =  i18n.t('editThreadSuccessfully')
                this.alertType = 'success'
                this.alertValue = true
                this.fetchThreadsForActivity()
              }
          } catch (e) {
            if(e.response){
              this.alertValue = true
              if(e.response.status == 403){
                  this.$router.push({name: 'PageAccessDenied'})
              } else if(e.response.status == 404) {
                    this.$router.push({name: 'PageNotFound'})
              } else {
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
              }
          }
        }
        this.dialogVisibleEditThread=false
    },
    async createComment(){
        this.valid = this.$refs.form.validate()
        if(this.valid && (this.comment != '' || this.attachmentsCount > 0)){
          this.commentIsDisabled = true
          try {
              let data = {
                  data: {
                    type: "comments",
                    attributes: {
                      comment: this.comment,
                      attachments : this.attachments
                    },
                    relationships: {
                      thread: {
                        data: {
                          type: "threads",
                          id: this.threadId
                        }
                      }
                    }
                  }

              };
              var response = await createComments(data);
              if(response){
                  if(response.status == 201) {
                    this.comment = ''
                    this.attachments = []
                      await this.fetchThreadComments()
                    // this.totalComments = this.totalComments + 1
                  }
              }
          } catch (e) {
              if(e.response){
                  this.alertValue = true
                  if (e.response.status == 422 ){
                      this.alertValue = true  
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  } else if (e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else {
                    this.alertValue = true
                    this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }else{
                    this.alertValue = true
                    this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')       
              }
          }
        }
        this.commentIsDisabled = false
      },
      async fetchThreadComments(){
          try {
              const response = await getThreadComments(this.threadId)
              if(response.status){
                  if(response.status == 200) {
                      this.comments = response.data.data;
                      this.totalComments = response.data.meta.count
                  }
              }      
          } catch (e) {
              if(e.response){
                  if(e.response.status == 404) {
                      this.$router.push({name: 'PageNotFound'})
                  }
                  else if(e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
              }            
          }
      },
      async removeThread(item){
          try{
              const response = await deleteThread(item)
              if(response.status == 204) {
                  this.dialogVisibleRemoveThread=false
                  await this.fetchThreadsForActivity()
                  this.showThread = false
              }
          } catch (e) {
              if(e.response){
                  this.alertValue = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('serverError')
              }
          }
      },
      async leaveThread(item){
            try{
               const response = await leaveThread(item)
                if(response.status == 200) {
                    this.dialogVisibleLeaveThread=false
                    await this.fetchThreadsForActivity()
                    this.showThread = false
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
      },
      async removeThreadComment(item){
      //remove comment
         try{
               const response = await deleteCommentThread(item)
                if(response.status == 200) {

                    this.dialogVisibleRemoveThreadComment=false
                    this.alertValue = true
                    this.alertType = 'success'
                    this.alertMsg =  i18n.t('commentRemovedByOwner')
                    await this.fetchThreadComments()
                    this.showThread = true
                    
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }
            }
      },
      async pinThreadComment(item){
      //pin comment
      if(item.attributes.is_pinned == false){
            try{
                let data = {
                        data: {
                          id: item.id,
                          type: "comments",
                          attributes: {
                              is_pinned: true
                          },
                          relationships: {
                            thread: {
                              data: {
                                type: "threads",
                                id: this.threadId
                              }
                            }
                          }
                        }

                    };
                
                    const response = await pinCommentThread(item.id,data)
                      if(response.status == 200) {
                          await this.fetchThreadComments()
                          this.showThread = true
                          
                      }
            } catch (e) {
                if(e.response){
                  if (e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
                }
            }
        }else {
            try{
                let data = {
                        data: {
                          id: item.id,
                          type: "comments",
                          attributes: {
                              is_pinned: false
                          },
                          relationships: {
                            thread: {
                              data: {
                                type: "threads",
                                id: this.threadId
                              }
                            }
                          }
                        }

                    };
                
                    const response = await pinCommentThread(item.id,data)
                      if(response.status == 200) {
                          await this.fetchThreadComments()
                          this.showThread = true
                          
                      }
            } catch (e) {
                if(e.response){
                     if (e.response.status == 403){
                      this.$router.push({name: 'PageAccessDenied'})
                  } else {
                      this.alertValue = true
                      this.alertType = 'error'
                      this.alertMsg =  i18n.t('serverError')
                  }
                }
            }
        }
    },
    async subscribeForEmailNotification(item){
      try{
          const response = await subscribeToThread(item)
          if(response.status == 200) {
            this.dialogVisibleSubscribeThread =false
            await this.fetchThreadsForActivity()
            this.showThread = false
          }
      } catch (e) {
        if(e.response){
            if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
            } else if (e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
            } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
            }
        }
      }
    },
    async unsubscribeForEmailNotification(item){
      try{
          const response = await unsubscribeToThread(item)
          if(response.status == 200) {
              this.dialogVisibleUnsubscribeThread =false
              await this.fetchThreadsForActivity()
              this.showThread = false
          }
      } catch (e) {
        if(e.response){
            if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
            } else if (e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
            } else {
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
            }
        }
      
      }
    },
    async uploadFile(){
      if(this.attachmentsCount >= 5){
        return false
      }
      
            if(this.fileData){
                if(this.fileData.size > 5*1024*1024){
                    this.alertMsg = i18n.t('uploadAttachmentSizeError')
                    this.alertValue = true
                    this.alertType = 'error'
                }else {
                    this.loadingUpload = true
                    try {
                        let data = new FormData();
                        data.append('type', 'comment');
                        data.append('file', this.fileData);
                        data.append('space_id', this.spaceId);
                        
                       
                        const response = await uploadFileComment(this.threadId, data) 
                        if(response.status == 200) {
                          var attachmentslist = response.data
                          this.attachmentExtension = response.data.meta.title.split('.').pop()
                          this.attachmentIcon = this.attachmentIcons[this.attachmentIcons.findIndex(item => item.type == this.attachmentExtension)]
                          this.attachments.push({ title: attachmentslist.meta.title, ext: this.attachmentIcon,detail: attachmentslist.meta.detail})
                          this.loadingUpload = false
                        }
                    }catch(e){
                        if (e.response.status == 422 ){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                this.alertValue = true
                                this.alertType = 'error'
                                if(e.response.data.errors[i].meta[0].code == 'extensionUnsupported'){
                                    this.alertMsg =  i18n.t('uploadDocumentExtensionError')
                                }else {
                                    this.alertMsg = i18n.t('serverError')
                                }
                            }
                        }else if (e.response.status == 403){
                             for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'Storage is full'){
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('storageFullError')
                                }
                                else {
                                    this.$router.push({name: 'PageAccessDenied'})
                                }
                            }
                        }else{
                          this.alertValue = true
                          this.alertType = 'error'
                          this.alertMsg =  i18n.t('serverError')
                        }
                        this.loadingUpload = false
                    }
                }
               
            }
             
    },
    async removeFile(item){
            try {
                let data = {
                  data: {
                      type: "thread-files", 
                      attributes: {
                          path: item.detail
                      },
                  }
                }
                const response = await removeFileComment(this.threadId, data) 
                if(response.status == 200) {
                      this.attachments = this.attachments.filter(attachment => attachment.detail != item.detail)
                }
            }catch(e){
                this.alertValue = true
                this.alertType = 'error'
                this.alertMsg =  i18n.t('serverError')
            }
            
    }
    
  },
};
</script>
<style>
.navigation-drawer-desktop .v-navigation-drawer__content{
  background-color: white;
  overflow: hidden !important;
}
.navigation-drawer-mobile .v-navigation-drawer__content{
  background-color: white;
}
.comment-input.v-text-field .v-input__slot::after{
  border-style: none !important;
}
.thread-card{
  width: 100%;
  position: fixed;
  transform: translateZ(0);  
  -webkit-transform: translateZ(0);
  z-index:1;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-bottom: 1px solid transparent; 
}
.thread-comments{
  margin-top: 200px !important;
  overflow-y: auto;
  height: calc(100% - 200px);
} 
.comment-input .v-input__control{
   flex-wrap: unset;
}
.textarea-autosize{
  line-height: 1.35rem !important;
  background-color: white;
 
}
.textarea-autosize:last-child {
 border-bottom:1px solid var(--v-greytextlight-base) !important;
}
.dots-vertical {
    display: none;
}
.comment-item:hover .dots-vertical{
  display: initial;
}

.v-file-input {
  flex-direction: row-reverse;
}
.mdi-24px{
  font-size: 24px;
}
.attachments .mdi-download::before{
  margin-top: 2px;
}
.filled-row {
  background-color: white;
}
</style>